export default __webpack_public_path__ + "static/media/SaaSProductLandingPage.23ab5afb.jpeg";